import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface SessionPerformance {
  sessionId: string;
  sessionName: string;
  totalVotes: number;
  variantCount: number;
  status: string;
  createdAt: string;
}

interface Props {
  data: SessionPerformance[];
}

export const SessionPerformanceChart = ({ data }: Props) => {
  const chartData = data.slice(0, 10).map(session => ({
    name: session.sessionName.length > 20 
      ? session.sessionName.substring(0, 20) + '...' 
      : session.sessionName,
    votes: session.totalVotes,
    variants: session.variantCount,
  }));

  return (
    <Card className="bg-white/5 border-white/10">
      <CardHeader>
        <CardTitle className="text-white">Session Performance</CardTitle>
        <CardDescription className="text-gray-400">Votes and variants per session (top 10)</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
            <XAxis 
              dataKey="name" 
              className="text-xs"
              angle={-45}
              textAnchor="end"
              height={100}
              stroke="#9CA3AF"
            />
            <YAxis className="text-xs" stroke="#9CA3AF" />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'rgba(15, 23, 42, 0.95)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '6px',
                color: '#fff'
              }}
            />
            <Legend wrapperStyle={{ color: '#9CA3AF' }} />
            <Bar dataKey="votes" fill="#3B82F6" name="Total Votes" />
            <Bar dataKey="variants" fill="#8B5CF6" name="Variants" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
